import PropTypes from 'prop-types'

import { Box, IconButton, Drawer } from '@mui/material'
import { ReactComponent as X } from '../../../assets/icons/x.svg'

import styles from './styles'

const DrawerWrapper = ({ anchor = 'right', children, isOpen, onClose, fullscreen }) => {
  return (
    <Drawer anchor={anchor} open={isOpen} onClose={onClose}>
      <Box sx={styles.drawerContent} style={fullscreen ? {width: '100vw'} : null}>
        <Box sx={styles.closeButtonWrapper}>
          <IconButton onClick={onClose}>
            <X />
          </IconButton>
        </Box>
        {children}
      </Box>
    </Drawer>
  )
}

DrawerWrapper.propTypes = {
  anchor: PropTypes.string,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  fullscreen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
}

export default DrawerWrapper
